
import { axiosInstance } from "../utils/axiosInstance";
import { API_ENDPOINTS } from "../utils/constants";
import { showErrorNotification } from "../components/Notification";
import { AxiosResponse } from "axios";
import { getLocalStorageItem } from "../utils/storage";

interface User {
	id: string;
	fullName: string;
	email: string;
	profilePhoto?: string
}

interface UserSearchApiResponse {
	result: {
		items: User[];
	};
	error?: string | null;
	isSuccessful: boolean;
}

export const searchProxyUdyUser = async (value: string): Promise<User[]> => {
	try {
		const response: AxiosResponse<UserSearchApiResponse> = await axiosInstance.post(API_ENDPOINTS.PROXY_UDY_SEARCH, {
			orders: [
				{
					columnName: "fullName",
					directionDesc: false
				}
			],
			pageIndex: 0,
			pageSize: 10,
			search: value,
		});
		if (response.data.isSuccessful) {
			const users: User[] = response.data.result.items.map((item) => ({
				id: item.id,
				fullName: item.fullName,
				email: item.email,
				profilePhoto: item.profilePhoto,
			}));
			return users;
		} else {
			showErrorNotification(response.data.error || "An error occurred");
			return [];
		}
	} catch (error) {
		showErrorNotification();
		throw error;
	}
};


export const proxyUser = (userId: string) => {
	const adminId = getLocalStorageItem("ADMIN_ID") ?? "";
	try {
		const redirectToUserPage = () => {
			try {
				const adminBaseUrl = window.location.origin;
				let redirectUrl;

				switch (true) {
					case /localhost/.test(adminBaseUrl):
						redirectUrl = "https://localhost:8002/";
						break;
					case /eonayadmindev/.test(adminBaseUrl):
						redirectUrl = "https://eonaydev.icindekocvar.com/";
						break;
					case /eonayadmintest/.test(adminBaseUrl):
						redirectUrl = "https://eonaytest.icindekocvar.com/";
						break;
					case /eonayadminuat/.test(adminBaseUrl):
						redirectUrl = "https://eonayuat.icindekocvar.com/";
						break;
					default:
						redirectUrl = "https://eonay.icindekocvar.com/";
						break;
				}
				const queryString = `?ProxyID=${userId}&AdminID=${adminId}`;
				const fullRedirectUrl = `${redirectUrl}accounts/proxy-login${queryString}`;
				window.location.href = fullRedirectUrl;
			} catch (error) {
				console.error("Error redirecting to user page:", error);
			}
		};
		redirectToUserPage();
		return
	} catch (error) {
		console.error("Error redirecting to user page:", error);
	}
};